/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Modal, Input, Button, message as toaster } from 'antd';
import QRCode from 'qrcode';
import PropTypes from 'prop-types';
import { useTimer } from 'react-timer-hook';
import { useDispatch } from 'react-redux';
import * as Pusher from 'pusher-js';
import { isEmpty } from 'lodash';
import { Image, Text, Box, Flex, Button as AtomButton } from 'atoms';
import { theme } from 'styles/theme';
import { Rupee } from 'components';
import { getGenerateQR, triggerFailUPI } from 'store/collectionSlice';
import { getNotifications } from 'store/notificationSlice';
import {
	UPIAutoCompleteManual,
	ClearConfirmation,
	QRTimerConfirmation,
} from 'components/pages/collection';
import { useAuth } from 'hooks';
import RipplrLogo from 'assets/ripplr-logo.svg';
import ManualMode from 'assets/ManualMode.svg';

export const InputLabel = styled(Box)`
	position: absolute;
	top: -15px;
	left: 0px;
	z-index: 1;
	font-size: 8px;
	line-height: 10px;
	color: ${theme.colors.Jet};
`;

export const InputField = styled(Input)`
	width: 100%;
	height: 32px;
	padding: 0 26px 0 12px;
	border: 0;
	font-size: 10px;
	background-color: #f6f6f6;
`;

export const SubmitBtn = styled(AtomButton)`
	background-color: #0ba86e;
	text-align: center;
	padding: 0;
	border: 0;
	outline: none;
	width: 100%;
	height: 40px;
	line-height: 40px;
`;

const ONE_SECOND = 1000;
const INTERVAL_CYCLE = 80 * ONE_SECOND; // each cycle 15 seconds interval
let pusher = null;

const cashierVerifiedStatus = (value) =>
	['VerifiedByCashier', 'PartialVerifiedByCashier']?.includes(value.invoice_verification_status);

export default function DynamicQRCode({
	visible,
	handleCancel,
	totalOutstanding,
	upiData,
	storeData,
	dynamicUPIData,
	setDynamicUPIData,
	manualModeEditData,
	formRef,
	handleDeleteManualUPI,
	handleQRCodeSubmit,
	storeInvoices,
}) {
	const [upiAmount, setUPIAmount] = useState(''); // Entered Amount
	// const [upiUPIRef, setUPIRef] = useState('');
	const [mode, setMode] = useState(null); // Manual || qrcode
	const [QRCodeImg, setQRCodeImg] = useState(null);
	const [showUpiPopup, setShowUpiPopup] = useState(false);
	const [deleteConfirmation, setDeleteConfirmation] = useState(false);
	const [qrTimerClose, setQrTimerClose] = useState(false);
	const [triggerCount, setTriggerCount] = useState(3);
	const dispatch = useDispatch();
	const intervalRef = useRef(null);
	const { id } = useAuth();
	const pusherData = useRef();

	const time = new Date();

	time.setSeconds(time.getSeconds() + INTERVAL_CYCLE);
	const { seconds, minutes, isRunning, restart } = useTimer({
		time,
		onExpire: () => console.warn('onExpire called'),
	});

	function triggerTimer() {
		const triggerTime = new Date();

		triggerTime.setSeconds(
			triggerTime.getSeconds() + (triggerCount * INTERVAL_CYCLE) / ONE_SECOND
		);
		restart(triggerTime);
	}

	const clearTimer = () => {
		clearInterval(intervalRef.current);
		intervalRef.current = null;
	};

	const handleManualModeClick = useCallback(() => {
		setShowUpiPopup(true);
		setMode('Manual');
		clearTimer();
		setQRCodeImg(null); // on manual mode switch clear the qr code
	}, []);

	const cashierVerified = useMemo(
		() => storeInvoices?.some(cashierVerifiedStatus),
		[storeInvoices]
	);

	useEffect(() => {
		/**
		 * On component load clear already added data
		 */
		if (visible) {
			setUPIAmount('');
			setMode(null);
			setQRCodeImg(null);
			setShowUpiPopup(false);
			setTriggerCount(3);
		} else {
			setShowUpiPopup(false);
		}

		return () => clearTimer();
	}, [visible]);

	function handleFailUPI() {
		const secondsFinished = minutes * 60 + seconds;
		// If popup closed with in 100 seconds send the reason as `PopUpClosed`

		if (upiAmount) {
			dispatch(getNotifications(id));
			dispatch(
				triggerFailUPI({
					store_id: storeData?.store_id,
					user_id: storeData?.salesman_id,
					amount: upiAmount,
					reason: secondsFinished > 140 ? 'PopUpClosed' : 'TimedOut',
				})
			);
		}
	}

	useEffect(() => {
		if (manualModeEditData?.isManualEditMode) {
			handleManualModeClick();
			setUPIAmount(manualModeEditData?.data?.amount?.toString());
			// setUPIRef(manualModeEditData?.data?.reference_number?.toString());
		}
	}, [handleManualModeClick, manualModeEditData]);

	useEffect(() => {
		console.log('isRunning', isRunning);
		if (!isRunning) {
			setUPIAmount('');
			setMode(null);
			setQRCodeImg(null);
			handleFailUPI();
		}
	}, [isRunning]);

	const showSuccessMessage = (data = {}) => {
		console.log('data', data);
		const { batchAmtCcd = 'INR', batchAmt = 0, utrNo, productCode } = data || {};

		toaster.success(`${batchAmtCcd} ${batchAmt} Received. Reference Number is ${utrNo}`);

		const saveData = {
			reference_number: utrNo,
			bank_statement_id: null,
			upiAmount: Number(batchAmt),
			type: productCode === 'UPICOLL' ? 'qrcode' : 'Manual',
		};

		handleQRCodeSubmit(saveData);
		clearTimer();
	};

	useEffect(() => {
		console.log('useEffect pusherData', pusherData);
		if (id && !pusherData.current && visible) {
			pusher = new Pusher(process.env.REACT_APP_PUSHER_CODE, {
				cluster: 'ap2',
				forceTLS: true,
			});

			console.log('channel id', `salesman_${id}`);

			const channel = pusher.subscribe(`salesman_${id}`);

			console.log('channel', channel);

			/** *
			 * add pusher details to ref, this will create channel one time only
			 */
			pusherData.current = pusher;

			console.log('pusherData.current', pusherData.current);

			/**
			 * Channels
			 */
			/**
			 * Events
			 */
			channel.bind('upi_payment', (data) => {
				console.log('upi_payment', data);
				showSuccessMessage(data?.message?.body);
			});
		} else {
			console.log('pusher already added Dynamic QR', pusherData, pusher);
		}

		return () => {
			console.log('came to last return');
			console.log('pusher', !isEmpty(pusher));
			console.log('id', id);
			console.log('visible', visible);
			console.log('all logic data', !isEmpty(pusher) && id && !visible);

			if (!isEmpty(pusher) && id && visible) {
				console.log('came for unsubscribe');
				pusher.unsubscribe(`salesman_${id}`);
				pusherData.current = null;
			}
		};
	}, [id, visible]);

	const extraAllowedAmount = useMemo(
		() => {
			const extra = Number(totalOutstanding);

			return extra > 100000 ? 100000 : extra;
		}, // allow extra 600 from collectable amount
		[totalOutstanding]
	);

	const handleChange = (e) => {
		const { value } = e.target;
		// const extraAllowedAmount = Number(totalOutstanding) + 600; // allow extra 600 from collectable amount

		setQRCodeImg(null); // on amount change clear the qr code
		setUPIAmount(Number(value));
		setMode(null);
	};

	function getUTRRefDetails(maxCycleCount) {
		setTriggerCount(maxCycleCount);
		clearTimer();
		triggerTimer();
	}

	function handleDynamicQRCode() {
		clearTimer();
		dispatch(
			getGenerateQR({
				store_id: storeData?.store_id,
				user_id: storeData?.salesman_id,
				amount: upiAmount,
			})
		)
			.then((res) => {
				QRCode.toDataURL(res?.upi_link, (err, qr) => {
					if (err) {
						toaster.error('Unable to generate UPI QR Code.');
					} else {
						setQRCodeImg(qr);
						setMode('qrcode');
						getUTRRefDetails(3);
					}
				});
			})
			.catch((err) => {
				console.log('err err err ', err);
				handleFailUPI();
			});
	}

	function handleDeleteCurrentRecord() {
		setDeleteConfirmation(false);
		/**
		 * On delete confirmation delete current selected manual upi data
		 */
		formRef.current.setValues({
			...formRef.current.values,
			upiData: formRef.current.values.upiData.filter(
				(upi) => upi.id !== manualModeEditData?.data?.id
			),
		});
		setTimeout(() => {
			handleCancel();
			handleDeleteManualUPI();
		}, 100);
	}

	function handleClose() {
		handleFailUPI();
		setQrTimerClose(false);
		setTimeout(() => {
			handleCancel();
		}, 1500);
	}

	function handleQRPopupClose() {
		const secondsFinished = minutes * 60 + seconds;

		console.log({ secondsFinished });

		if (QRCodeImg && upiAmount && mode === 'qrcode' && secondsFinished > 140) {
			setQrTimerClose(true);
		} else {
			handleClose();
		}
	}

	const amount_state = ['EDITAMOUNT', 'EDITAMOUNTORDATA', '', 'DEFAULT'];
	const getAmountState = (val) => {
		console.log(val);
		if (amount_state.includes(val?.state) || val?.state === undefined) {
			return false;
		}
		if (val?.state === 'PERSIST') {
			return true;
		}

		return true;
	};

	// const onlyamoun = ['EDITAMOUNT'];

	// const getOnlyAmounyState = (val) => !!onlyamoun.includes(val?.state);

	// const data_state = ['EDITDATA', 'EDITAMOUNTORDATA', '', 'DEFAULT'];
	// const getDataStateCheck = (val) => {
	// 	if (data_state.includes(val?.state) || val?.state === undefined) {
	// 		return false;
	// 	}
	// 	if (val?.state === 'PERSIST') {
	// 		return false;
	// 	}

	// 	return true;
	// };

	console.log(totalOutstanding, 'totalOutstanding');

	return (
		<Modal
			title={
				<Box>
					<Image
						src={RipplrLogo}
						alt="Ripplr Logo"
						style={{
							width: 'auto',
							height: '20px',
						}}
					/>
				</Box>
			}
			visible={visible}
			onCancel={handleQRPopupClose}
			style={{
				width: '90%',
			}}
			maskClosable={false}
			footer={null}
		>
			<Text textAlign="center" fontSize="10px" color={theme.colors.DavysGrey}>
				Collectable Amount:
			</Text>
			<Text textAlign="center" fontSize="16px" fontWeight="600">
				<Rupee>{totalOutstanding}</Rupee>
			</Text>

			<Flex my="1.25rem" alignItems="center">
				<Box width="70%">
					<InputLabel>Enter Amount</InputLabel>
					<InputField
						value={upiAmount}
						placeholder="₹"
						onChange={handleChange}
						type="number"
						min="1"
						max={extraAllowedAmount > 100000 ? 100000 : extraAllowedAmount}
						disabled={getAmountState(manualModeEditData?.data)}

						// || QRCodeImg || !upiData
					/>
					{/* Allow max UPI amount as 100000 (1 lakh) only */}
				</Box>

				<Button
					type="primary"
					onClick={handleDynamicQRCode}
					disabled={!upiAmount || QRCodeImg || !upiData || cashierVerified}
				>
					Generate QR
				</Button>
			</Flex>

			{/* <Flex>
				{getOnlyAmounyState(manualModeEditData?.data) && (
					<Box width="100%">
						<InputLabel>*UTR Ref no:</InputLabel>
						<InputField
							value={upiUPIRef}
							type="string"
							min="1"
							disabled={getDataStateCheck(manualModeEditData?.data)}
						/>
					</Box>
				)}
			</Flex> */}
			{/* <Flex my="1.25rem" alignItems="center">
				<Button
					type="primary"
					onClick={handleFailUPI}
					disabled={!upiAmount || QRCodeImg || !upiData}
				>
					Fail UTR
				</Button>
			</Flex> */}
			{!upiData && (
				<Text color="red" fontSize="10px" textAlign="center">
					* UPI QR Code Not Available, contact support team
				</Text>
			)}
			<Box minHeight={mode === 'Manual' ? '0px' : '100px'}>
				{QRCodeImg && upiAmount && mode === 'qrcode' && (
					<Flex
						justifyContent="center"
						alignItems="center"
						mb="1rem"
						flexDirection="column"
					>
						<Image src={QRCodeImg} alt="qrCode" height={240} width={240} />
						{isRunning && (
							<Text
								fontWeight="600"
								fontSize="16px"
								color={minutes < 1 ? 'red' : 'black'}
							>
								<span>{minutes}</span>:<span>{seconds < 10 ? '0' : ''}</span>
								<span>{seconds}</span>
							</Text>
						)}
					</Flex>
				)}
			</Box>
			{upiAmount && mode === 'Manual' && (
				<>
					{manualModeEditData?.isManualEditMode && (
						<Flex alignItems="center" justifyContent="space-between">
							<AtomButton
								variant="danger"
								onClick={() => setDeleteConfirmation(true)}
								disabled={cashierVerified}
							>
								Delete Record?
							</AtomButton>
						</Flex>
					)}
					<UPIAutoCompleteManual
						showUpiPopup={showUpiPopup}
						storeData={storeData}
						setDynamicUPIData={setDynamicUPIData}
						upiAmount={upiAmount}
						cashierVerified={cashierVerified}
						manualModeEditData={manualModeEditData}
					/>
					{dynamicUPIData?.reference_number && (
						<Flex justifyContent="center" alignItems="center" mt="1rem">
							<SubmitBtn
								onClick={() => {
									handleQRCodeSubmit({
										...dynamicUPIData,
										manualModeEditData,
									});
								}}
								disabled={!dynamicUPIData?.reference_number}
							>
								{manualModeEditData?.isManualEditMode ? 'Update' : 'Submit'}
							</SubmitBtn>
						</Flex>
					)}
				</>
			)}
			{mode !== 'Manual' && (
				<Flex alignItems="center" justifyContent="space-between" mt="1rem">
					<Text color={theme.colors.DimGray} fontSize="10px" mb="0.5rem" maxWidth="100px">
						If there is problem in generating QR Code then please use
					</Text>
					<Button
						className="center"
						onClick={handleManualModeClick}
						disabled={!upiAmount || QRCodeImg}
						type={mode === 'Manual' && 'primary'}
					>
						<Flex justifyContent="center" alignItems="center">
							<Text as="span" pr="0.5rem">
								Add Manually here
							</Text>
							<Image src={ManualMode} alt="ManualMode" height={17} width={18} />
						</Flex>
					</Button>
				</Flex>
			)}
			<ClearConfirmation
				visible={deleteConfirmation}
				onClose={() => setDeleteConfirmation(false)}
				onClear={handleDeleteCurrentRecord}
				infoText="Are you sure want to delete the record?"
				yesText="Yes"
			/>
			<QRTimerConfirmation
				visible={qrTimerClose}
				onClose={() => setQrTimerClose(false)}
				onClear={handleClose}
				infoText="The payment process is currently underway. Are you certain you want to close?"
				yesText="Yes"
			/>
		</Modal>
	);
}

DynamicQRCode.propTypes = {
	visible: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
	totalOutstanding: PropTypes.number.isRequired,
	upiData: PropTypes.string,
	storeData: PropTypes.object,
	dynamicUPIData: PropTypes.object,
	setDynamicUPIData: PropTypes.func.isRequired,
	manualModeEditData: PropTypes.object,
	formRef: PropTypes.object,
	handleDeleteManualUPI: PropTypes.func.isRequired,
	handleQRCodeSubmit: PropTypes.func.isRequired,
	storeInvoices: PropTypes.any,
};
